import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRetrieveLeague } from "../api/LeagueApiProvider";
import { useAddVenueToLeague, useListLeagueHomeVenues, } from "../api/LeagueVenueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { safeReturnTo } from "../utils/safeReturnTo";
import { useNumericParams } from "../utils/useNumericParams";
import { AddVenueToEntity } from "../venues/AddVenueToEntity";
export const AddVenueToLeague = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { id: leagueId } = useNumericParams();
    const returnTo = searchParams.get("returnTo");
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeaguePermissions({ leagueId });
    const { canModify = false } = permissions || {};
    const { data: league, isLoading: leagueLoading } = useRetrieveLeague({
        id: leagueId,
        enabled: canModify,
    });
    const { data: existingVenues, isLoading: venuesLoading, error: venuesError, } = useListLeagueHomeVenues({
        leagueId,
        enabled: !!leagueId && canModify,
    });
    const addVenueMutation = useAddVenueToLeague({
        leagueId,
        onSuccess: () => {
            navigate(safeReturnTo(returnTo, `/leagues/${leagueId}/venues/`));
        },
        onError: () => { },
    });
    const handleAdd = (venueId, fromDate) => {
        if (!leagueId)
            return;
        addVenueMutation.mutate({
            league: leagueId,
            venue: venueId,
            ...(fromDate && { fromDate }),
        });
    };
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    // Also gate on the home-venues query: it feeds the duplicate-prevention guard,
    // so rendering before it resolves (or after it errors) would offer an
    // already-home venue and allow a duplicate add.
    if (leagueLoading || venuesLoading) {
        return _jsx(Loading, {});
    }
    if (!league || !leagueId || venuesError) {
        return _jsx(ErrorView, {});
    }
    // Get IDs of active venues to filter from search results
    const existingVenueIds = existingVenues?.filter((v) => v.isActive).map((v) => v.venue.id) || [];
    return (_jsx(AddVenueToEntity, { entityName: "league", entityDisplayName: league.name, entityId: leagueId, cancelUrl: `/leagues/${leagueId}/venues/`, existingVenueIds: existingVenueIds, addMutation: addVenueMutation, onAdd: handleAdd }));
};
